/* eslint no-magic-numbers: 0 */
export default function remove(array, item) {
   const idx = array.indexOf(item);
   if ( idx >= 0 ) {
      array.splice(idx, 1);
   }
}
